// extracted by mini-css-extract-plugin
module.exports = {"maximalMobileWidth":"580px","maximalTabletWidth":"1024px","container":"DefaultLayout_container__ytuV_","content":"DefaultLayout_content__2LR4D"};